import { render, staticRenderFns } from "./TaxTransitionArea.vue?vue&type=template&id=063747e3&scoped=true&"
import script from "./TaxTransitionArea.vue?vue&type=script&lang=js&"
export * from "./TaxTransitionArea.vue?vue&type=script&lang=js&"
import style0 from "./TaxTransitionArea.vue?vue&type=style&index=0&id=063747e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063747e3",
  null
  
)

export default component.exports